import { Stack } from 'expo-router';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants';
import { routes } from 'utils/routing';

export default function OffersLayout() {
  useStoreRequired(
    Boolean(useFlag(LaunchDarklyFlag.FORCE_RESTAURANT_SELECTION_FOR_REWARDS)),
    undefined,
    routes.offers
  );

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          header: () => <StandardMobileHeader />,
          headerShown: true,
        }}
      />
      {/* NOTE: modals are in (modals) */}
    </Stack>
  );
}
